/**
 * 处理直播间消息 LOVE_ROOM_MESSAGE
 *
 * 职责：
 * 1. 接收 IM 推送的直播间消息
 * 2. 添加到 videoCallStore 的消息列表中
 * 3. 不保存到 IndexedDB
 */

import { useVideoCallStore } from '@/stores/videoCall'
import { VIDEO_MSG_TYPES } from '@/common/constants/videoMsgTypes'

/**
 * @param {Object} event - EventBus 事件对象
 * @param {Object[]} event.data - IMManager 派发的消息数组
 */
export function handleVidelCallMessages(event) {
  console.log('[handleVidelCallMessages] event:', event)
  const { data: messages } = event
  if (!Array.isArray(messages) || messages.length === 0) return

  const videoCallStore = useVideoCallStore()
  const currentRoomInfo = videoCallStore.currentRoomInfo

  // 只处理当前直播间的消息
  if (!currentRoomInfo) {
    return
  }

  // 添加到 videoCallStore 的消息列表
  videoCallStore.addMessages(
    messages
      // .filter(message => message.live_id === currentRoomInfo.live_id) // 有些消息没有live_id，所以不过滤
      .map((message, index) => ({
        ...message,
        id: `${message.client_id}-${message.timestamp}-${index}`,
        type: VIDEO_MSG_TYPES.TEXT,
      })))
}
